/**
 * Flow editor — note-brush catalog.
 *
 * Static descriptors for the note-type and flick-direction brushes shown in the
 * right sidebar. Pure data (no React/store deps) so it can be imported by the
 * editor UI and any tooling/tests without pulling in FlowApp.
 */

import { type FlowNoteType } from './types';

export interface NoteTypeInfo {
  key: FlowNoteType | 'trail';
  label: string;
  short: string;
  tooltip: string;
}

export const NOTE_TYPE_INFO: NoteTypeInfo[] = [
  {
    key: 'tap',
    label: 'NOTE',
    short: 'Standard note',
    tooltip: 'Standard note — the default brush.',
  },
  {
    key: 'trail',
    label: 'TRAIL',
    short: 'Long note',
    tooltip: 'Two-click trail (sustain). First click sets the start (highlighted white), second click sets the end. ESC to cancel.',
  },
];

export interface FlickNoteInfo {
  key: 'arrow-left' | 'arrow-center' | 'arrow-right';
  glyph: string;
  label: string;
  tooltip: string;
}

export const FLICK_NOTE_INFO: FlickNoteInfo[] = [
  { key: 'arrow-left',   glyph: '↖', label: 'Left',   tooltip: 'Flick note pointing DIAGONAL UP-LEFT.' },
  { key: 'arrow-center', glyph: '↑', label: 'Center', tooltip: 'Flick note pointing FORWARD / UP.' },
  { key: 'arrow-right',  glyph: '↗', label: 'Right',  tooltip: 'Flick note pointing DIAGONAL UP-RIGHT.' },
];
